<mat-dialog-content>
  <h1 mat-dialog-title>Choix du modèle de notification</h1>

  <mat-divider></mat-divider>
  <div class="list-container">

    <div [formGroup]="form">

      @if (notificationsEligibles) {
        <mat-selection-list formControlName="notificationsForm" [multiple]="false">
          @for (group of notificationsEligibles | keyvalue; track group) {
            <h3 matSubheader>{{ group.value.label }}</h3>
            @for (item of group.value.notifications; track item) {
              <mat-list-option [value]="item">
                <div matListItemAvatar>
                  <div class="avatar-{{ item.avatar }}">{{ item.avatar }}</div>
                </div>
                <h3 matListItemTitle>{{ item.mailCode.label }} @if (item.cs) {
                  <span>- {{item.cs}} {{item.csDecisive ? ' - Décisive' : ''}}</span>
                }</h3>
                <div matListItemLine class="text-gray">
                  {{ item.description }}
                </div>
              </mat-list-option>
            }
          }
        </mat-selection-list>
      }

    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="[]">Annuler</button>
  <button mat-raised-button color="warn" [disabled]="!form.valid"
    [mat-dialog-close]="form.get('notificationsForm').value">Copier cette notification
  </button>
</mat-dialog-actions>
